import { render, staticRenderFns } from "./ServiceListingWidgets.vue?vue&type=template&id=684cf274&"
import script from "./ServiceListingWidgets.vue?vue&type=script&lang=js&"
export * from "./ServiceListingWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684cf274')) {
      api.createRecord('684cf274', component.options)
    } else {
      api.reload('684cf274', component.options)
    }
    module.hot.accept("./ServiceListingWidgets.vue?vue&type=template&id=684cf274&", function () {
      api.rerender('684cf274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ServiceListingWidgets.vue"
export default component.exports